import actions from "redux-form/lib/actions";
import {
    DINING,
    DINING_SUCCESS,
    DINING_ERROR,
    ADD_DINING,
    ADD_DINING_SUCCESS,
    ADD_DINING_ERROR,
    UPDATE_DINING,
    UPDATE_DINING_SUCCESS,
    UPDATE_DINING_ERROR,
    DELETE_DINING,
    DELETE_DINING_ERROR,
    DELETE_DINING_SUCCESS,
    GET_DINING_IMAGES,
    GET_DINING_IMAGES_ERROR,
    GET_DINING_IMAGES_SUCCESS,
    GET_WEEK_DININGS,
    GET_WEEK_DININGS_ERROR,
    GET_WEEK_DININGS_SUCCESS,
    DINING_TAGS,
    DINING_TAGS_ERROR,
    DINING_TAGS_SUCCESS,
    DINING_FILTERS,
    DINING_FILTERS_ERROR,
    DINING_FILTERS_SUCCESS,
    BATCH_DELETE_DINING_SUCCESS,
    DELETE_ALL_DINING_SUCCESS
} from "../constants/diningConstants";

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: '',
    tags:[]
};

export function diningReducer(state = initialState, action) {
    switch (action.type) {
        case DINING:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'MEAL',
                'loadingMessage': 'THE MEALS ARE BEING LOADED',
                'type': action.type
            });
        case DINING_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DINING_SUCCESS:
            const communityIdNewMeals = (action && action.communityId)? action.communityId: '';

            let oldData = (state && state.diningData && state.diningData.data && state.diningData.data.length  >0)? state.diningData.data : [];
            const communityIdInOldData = (oldData && oldData[0] &&  oldData[0].communityId)? oldData[0].communityId : '';

            if (oldData && oldData.length> 0 && communityIdNewMeals === communityIdInOldData) {
                const oldDining = oldData.filter(dining => !action.data.data.some(newMeal => newMeal._id === dining._id));
                action.data.data = oldDining.concat(action.data.data);
            }

            action.data.data.sort((a, b) => {

                if (new Date(a.dateStart) > new Date(b.dateStart)) {
                    return 1;
                } else {
                    return -1;
                }
            });

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'diningData': action.data
            });
        case ADD_DINING:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'MEAL',
                'loadingMessage': 'THE MEAL (S) ARE BEING SAVED',
                'type': action.type
            });
        case ADD_DINING_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_DINING_SUCCESS:

            let addDiningData = state.diningData ? [...state.diningData.data] : []

            action.data.data = addDiningData;

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'diningData': action.data
            });
        case UPDATE_DINING:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'MEAL',
                'loadingMessage': 'THE MEAL (S) ARE BEING UPDATED',
                'type': action.type
            });
        case UPDATE_DINING_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_DINING_SUCCESS:
            const oldDiningData = state.diningData ? state.diningData : []
            let newDiningData
            if (typeof (oldDiningData) === 'object' && oldDiningData.length > 0) {
                newDiningData = oldDiningData.map(dining => {

                    if (dining._id === action.data._id) {
                        return action.data
                    } else {
                        return dining
                    }
                })
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'diningData': newDiningData
            });
        case DELETE_DINING:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'MEAL',
                'loadingMessage': 'THE MEAL (S) ARE BEING DELEATED',
                'type': action.type
            });
        case DELETE_DINING_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_DINING_SUCCESS:
            const oldMeals= (state.diningData)? state.diningData : {};
            const oldMealsData=  (oldMeals && oldMeals.data)? oldMeals.data : [];

            const newMealsData= (oldMealsData && oldMealsData.length > 0  && actions.data)? oldMealsData.filter(dining => dining._id !== action.data): [];
            let newMeals =oldMeals;
            newMeals.totalDinings = newMealsData.length;
            newMeals.data = newMealsData;

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'diningData': newMeals
            });

        case BATCH_DELETE_DINING_SUCCESS:
            const oldDinings = ( state?.diningData?.data)? state.diningData.data : [];

            const filteredDinings=(oldDinings && oldDinings.length > 0  && actions.data)? oldDinings.filter(d => {
                return !action.data.find(element => (element._id === d._id));
            }): [];
            
            let newObj = {
                totalDinings: filteredDinings.length,
                data: filteredDinings,
            };
    
                return Object.assign({}, state, {
                    'loading': false,
                    'success': true,
                    'error': '',
                    'type': action.type,
                    'diningData': newObj
                });

        case DELETE_ALL_DINING_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'diningData': []
            });
        
        case GET_DINING_IMAGES:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'MEAL',
                'loadingMessage': 'THE MEALS IMAGES ARE BEING LOADED',
                'type': action.type
            });
        case GET_DINING_IMAGES_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_DINING_IMAGES_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'diningImages': action.data

            });
        case GET_WEEK_DININGS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'MEAL',
                'loadingMessage': 'THE MEALS ARE BEING LOADED',
                'type': action.type
            });
        case GET_WEEK_DININGS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_WEEK_DININGS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'weekDinings': action.data
            });
        case DINING_TAGS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DINING',
                'loadingMessage': 'THE DINING TAGS ARE BEING LOADED',
                'type': action.type
            });
        case DINING_TAGS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DINING_TAGS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'tags': action.data
        
            });
        case DINING_FILTERS:
            return Object.assign({}, state, {
                    'loading': true,
                    'success': false,
                    'error': '',
                    'loadingTitle': 'DINING',
                    'loadingMessage': 'THE FILTERS ARE BEING APPLIED',
                    'type': action.type
                });
        case DINING_FILTERS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
            
        case DINING_FILTERS_SUCCESS:
            
            const commIdNewAct = (action && action.communityId)? action.communityId: '';
        
                let filtersOldData = (state && state.diningData && state.diningData.data && state.diningData.data.length  >0)? state.diningData.data : [];
                const commIdInOldData = (filtersOldData && filtersOldData[0] &&  filtersOldData[0].communityId)? filtersOldData[0].communityId : '';
                
                if (state.diningData && commIdNewAct === commIdInOldData && action.currentPage >0) {
                    const oldDinings = filtersOldData.filter(dining => !action.data.data.some(newIssue => newIssue._id === dining._id));
        
                    let diningSorting = action.data ? action.data.data : [];
        
                    action.data.data = oldDinings.concat(diningSorting);
                } 
        
                return Object.assign({}, state, {
                    'loading': false,
                    'success': true,
                    'error': '',
                    'diningData': action.data,
                    'type': action.type
        
                });
    
        default:
            return state;
    }
}

export default diningReducer;

